import { render } from "./KBSearch.vue?vue&type=template&id=04d459f4&scoped=true"
import script from "./KBSearch.vue?vue&type=script&lang=js"
export * from "./KBSearch.vue?vue&type=script&lang=js"

import "./KBSearch.vue?vue&type=style&index=0&id=04d459f4&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d459f4"]])

export default __exports__